import { render, staticRenderFns } from "./uploaddocument.vue?vue&type=template&id=c34c9a98&scoped=true"
import script from "./uploaddocument.vue?vue&type=script&lang=js"
export * from "./uploaddocument.vue?vue&type=script&lang=js"
import style0 from "./uploaddocument.vue?vue&type=style&index=0&id=c34c9a98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c34c9a98",
  null
  
)

export default component.exports